export default __webpack_public_path__ + "static/media/Profile.6e1f5769.svg";